import { createReducer } from '@reduxjs/toolkit';
import _ from 'lodash';
import { TYPES } from '../../common/constants';

const fetchItemsDone = (items, { payload }) => {
  return [
    ...payload,
  ];
};

const saveItemDone = (items, { payload }) => {
  return [
    ...items,
    payload,
  ];
}

const fetchItemNotesDone = (items, { payload }) => {
  return items.map(p => {
    if (p.id === payload.id) {
      return {
        ...p,
        notes: payload.notes,
      };
    }
    return p;
  });
};

const fetchItemDocumentsDone = (items, { payload }) => {
  return items.map(p => {
    if (p.id === payload.id) {
      return {
        ...p,
        documents: payload.documents,
      };
    }
    return p;
  });
};

const fetchItemFaqsDone = (items, { payload }) => {
  if (_.some(items, { id: payload.id })) {
    return items.map(p => {
      if (p.id === payload.id) {
        return {
          ...p,
          faqs: payload.faqs,
        };
      }
      return p;
    });
  }
  return [
    ...items,
    {
      id: payload.id,
      faqs: payload.faqs,
    }
  ];
};

const saveFaqDone = (items, { payload }) => {
  return items.map(c => {
    if (c.id === payload.id) {
      return {
        ...c,
        faqs: [
          ...c.faqs,
          payload.faq,
        ],
      };
    }
    return c;
  });
};

const deleteItemDone = (items , { payload }) => {
  return items.filter( i => i.id !== payload)
}

const updateItemDone = (items, { payload }) =>{
  return items.map( i => {
    if(i.id === payload.id){
      return payload
    }
    return i
  })
}

const initialState = [];

export default createReducer(initialState, {
  [TYPES.FETCH_ITEMS_DONE]: fetchItemsDone,
  [TYPES.SAVE_ITEM_DONE]: saveItemDone,
  [TYPES.DELETE_ITEM_DONE]:deleteItemDone,
  [TYPES.UPDATE_ITEM_DONE]:updateItemDone,
  [TYPES.FETCH_ITEM_NOTES_DONE]: fetchItemNotesDone,
  [TYPES.FETCH_ITEM_DOCUMENTS_DONE]: fetchItemDocumentsDone,
  [TYPES.FETCH_ITEM_FAQS_DONE]: fetchItemFaqsDone,
  [TYPES.SAVE_FAQ_DONE]: saveFaqDone,
});
